import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

export default trigger('zoomFadeIn', [
  transition('* => *', [
    query(':self', style({ opacity: 0 }), { optional: true }),
    query(
      ':self',
      stagger('300ms', [
        animate(
          '.5s ease-in',
          keyframes([
            style({ opacity: 0, transform: '', offset: 0 }),
            style({
              opacity: 0.5,
              transform: 'scale(1.1)',
              offset: 0.3,
            }),
            style({ opacity: 1, transform: '', offset: 1 }),
          ])
        ),
      ]),
      { optional: true }
    ),

    // query(
    //   ':leave',
    //   stagger('300ms', [
    //     animate(
    //       '500ms ease-out',
    //       keyframes([
    //         style({ opacity: 1, transform: '', offset: 0 }),
    //         style({ opacity: 0.5, transform: '', offset: 0.3 }),
    //         style({ opacity: 0, transform: '', offset: 1 }),
    //       ])
    //     ),
    //   ]),
    //   { optional: true }
    // ),
  ]),
]);
